import { compose } from 'redux';

export function getComposeEnhancers() {
    const reduxDevtoolsExtensionCompose =
        // @ts-expect-error
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const extensionOptions = {};

    return canInstallExtension()
        ? reduxDevtoolsExtensionCompose(extensionOptions)
        : compose;
}

function canInstallExtension() {
    return (
        typeof window === 'object' &&
        // @ts-expect-error
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    );
}
